<template>
    <div>
        <Transition name="fade">
            <div @click="closeAction" v-if="isOpen" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
        </Transition>
        <CommonPopupFrame :isShowBackground="false" :changeHeight="'auto'" :isOpen="isOpen" :closeCompleteAction="closeAction" :changeBottom="40">
            <div style="padding: 0 12px;">
                <div class="common_popup_header"></div>
                <div style="text-align: right; padding-right: 8px; margin-top: 14px;">
                    <img style="width: 15px;" :src="require('@/assets/img/x_btn_gray.png')" alt="" @click="closeAction">
                </div>
                <template v-if="feedbackMode === FEEDBACK_MODE.VIEW">
                    <div style="display: flex; align-items: center; gap: 10px; border-bottom: 1px solid #d9d9d9; padding-bottom: 20px;">
                        <div>
                            <ProfileImage style="width: 40px;" :image-path="feedbackInfo.image_path"></ProfileImage>
                        </div>
                        <div style="display: flex; flex-direction: column; gap: 5px;">
                            <div style="flex: 1; display: flex; align-items: center; gap: 3px;">
                                <div style="font-weight: 700; font-size: 14px;">{{ feedbackInfo.nic_name }}</div>
                                <div style="margin-left: 4px;">
                                    <img v-if="feedbackInfo.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                    <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                </div>
                            </div>
                            <div style="font-size: 12px; color: #606060;">{{ feedbackInfo.team_name }}</div>
                        </div>
                    </div>
                    <div style="margin-top: 20px;">
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px; word-break: break-all;">{{ feedbackInfo.contents }}</div>
                    </div>
                    <div @click="toggleLike" :class="feedbackInfo.like_yn == IS_LIKE.LIKE ? 'active' : ''" class="like_btn">
                        <img v-if="feedbackInfo.like_yn == IS_LIKE.LIKE" style="width: 16px;" src="@/assets/img/thumbs_up_white.png">
                        <img v-else style="width: 16px;" src="@/assets/img/thumbs_up_gray.png">
                        <span>도움이 되었어요</span>
                    </div>
                </template>
                <template v-else>
                    <div style="margin-top: 20px; padding: 0 12px;">
                        <div style="font-size: 20px; font-weight: 700; line-height: 32px;">전문가 피드백 작성하기</div>
                        <div style="font-weight: 500; font-size: 14px; margin-top: 5px; line-height: 24px; color: #797979;">회원님의 훈련 영상을 분석하고, 실력 향상에 도움되는 <span style="color: var(--color-main); font-weight: 700;">전문적인 조언</span>을 남겨주세요.</div>
                        <div style="margin-top: 15px;">
                            <textarea v-model="feedbackText" class="feedback_textarea" :placeholder="placeholder" name="" id=""></textarea>
                        </div>
                        <div style="margin-top: 26px;">
                            <div @click="submitFeedback" :class="feedbackText.length > 10 ? 'active' : ''" class="common_btn">피드백 등록하기</div>
                        </div>
                    </div>
                </template>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ProfileImage from '@/components/common/ProfileImage'
import { FEEDBACK_MODE, SOCCER_HOW_TYPE, TEAM_TYPE, IS_LIKE } from '@/Constants'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'ExpertFeedbackModal',
    components: { CommonPopupFrame, ProfileImage },
    props: {
        feedbackInfo: {
            type: Object,
            default: () => {}
        },
        feedbackMode: {
            type: String,
            default: FEEDBACK_MODE.VIEW
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        setLikeState: {
            type: Function,
            default: () => {}
        },
        index: {
            type: Number,
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => {}
        }
    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
    data() {
        return {    
            FEEDBACK_MODE: FEEDBACK_MODE,
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            TEAM_TYPE: TEAM_TYPE,
            IS_LIKE: IS_LIKE,
            isOpen: false,
            feedbackText: '',
            placeholder: '예) 전체적으로 움직임이 가볍고 플레이 템포가 안정적이네요. 기본기가 탄탄해서 실전 상황에서도 충분히 강점이 살아날 것 같습니다',
        }
    },
    methods: {
        closeAction() {
            this.isOpen = false;
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        async submitFeedback() {
            if (this.feedbackText === '') {
                this.$GlobalStore.showAlert('내용을 입력하세요')
                return
            }

            if (this.feedbackText.length < 10) {
                this.$GlobalStore.showAlert('10자 이상 작성하세요')
                return
            }

            const formData = new FormData()

            formData.append('contents', this.feedbackText);
            formData.append('parentIdx', this.soccerhowIdx);
            formData.append('type', SOCCER_HOW_TYPE.FEEDBACK);
            const res = await this.$Axios.post('/api/soccerhow/save', formData);

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.showAlert('피드백이 등록되었습니다.')
                this.completeAction()
                this.closeAction()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        async toggleLike() {
            const parameters = {};
            const curLikeNumber = parseInt(this.feedbackInfo.like_number);
            let likeTemp = this.feedbackInfo.like_yn == IS_LIKE.LIKE ? '0' : '1';
            let likeNumber = this.feedbackInfo.like_yn == IS_LIKE.LIKE ? curLikeNumber - 1 : curLikeNumber + 1;
            this.setLikeState(likeTemp, likeNumber, this.index);
            parameters.likeYn = likeTemp;
            parameters.idx = this.feedbackInfo.idx;
            const res = await this.$Axios.post('/api/soccerhow/like', parameters);
            if (res.data.code === -1) {
                alert(res.data.msg);
            }
        }
    }
}
</script>

<style scoped>
.common_popup_header {
    width: 36px;
    height: 5px;
    background-color: #d9d9d9;
    margin: 0 auto;
    border-radius: 5px;
    margin-top: 5px;
}

.like_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 286px;
    padding: 24px 0;
    background-color: #d9d9d9;
    border-radius: 50px;
    color: #797979;
    gap: 10px;
    font-size: 14px;
    font-weight: 700;
    margin: 0 auto;
    margin-top: 20px;
}

.like_btn.active {
    background-color: var(--color-main);
    color: #fff;
}

.feedback_textarea {
    outline: none;
    background-color: #210F030D;
    border-radius: 12px;
    padding: 10px 20px;
    line-height: 24px;
    font-size: 14px;
    width: 100%;
    min-height: 230px;
    border: none;
}

.common_btn {
    padding: 16px 0;
    color: #797979;
    font-size: 14px;
    font-weight: 700;
    border-radius: 12px;
    background-color: #d9d9d9;
    text-align: center;
}

.feedback_textarea::placeholder {
    color: #BBBBBB;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
}

.common_btn.active {
    background-color: #210F03;
    color: #fff;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>